var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3 40.1C76.3 20.2 60.2 4.09998 40.3 4.09998C20.4 4.09998 4.3 20.2 4.3 40.1C4.3 60 20.4 76.1 40.3 76.1C60.2 76.1 76.3 60 76.3 40.1ZM7.6 40.1C7.6 22 22.2 7.39998 40.3 7.39998C58.4 7.39998 73 22 73 40.1C73 58.2 58.4 72.8 40.3 72.8C22.2 72.8 7.6 58.2 7.6 40.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8 27.1C62.1 27.8 60.4 28.3 58.5 28.6C60.4 27.5 61.9 25.6 62.6 23.5C60.8 24.6 58.8 25.3 56.7 25.7C55 23.9 52.6 22.8 50 22.8C44.9 22.8 40.8 26.9 40.8 32C40.8 32.7 40.9 33.4 41 34.1C33.3 33.7 26.5 30 22 24.4C21.2 25.8 20.8 27.3 20.8 29C20.8 32.2 22.4 35 24.9 36.7C23.4 36.6 22 36.2 20.7 35.5V35.6C20.7 40.1 23.9 43.8 28.1 44.7C27.3 44.9 26.5 45 25.7 45C25.1 45 24.5 44.9 24 44.8C25.2 48.5 28.6 51.1 32.6 51.2C29.4 53.7 25.5 55.1 21.1 55.1C20.4 55.1 19.6 55.1 18.9 55C23 57.6 27.8 59.2 33.1 59.2C50.1 59.2 59.4 45.1 59.4 32.9V31.7C61 30.6 62.6 29 63.8 27.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/footer-twitter.d449809a.svg";
export { ForwardRef as ReactComponent };